import { render, staticRenderFns } from "./DiagnoseIcd10.vue?vue&type=template&id=c150c732&"
import script from "./DiagnoseIcd10.vue?vue&type=script&lang=js&"
export * from "./DiagnoseIcd10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports